import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import '../sass/App.scss';
import { Index } from './collection/Index';
import { checkEnvPurpleZone, getSearchParams, namespace } from './common/Utils';
import { PURPLEZONE_CHARACTER_ID_KEY, PURPLEZONE_SERVER_ID_KEY } from './common/constants';
import { Index as DetailIndex } from './detail/Index';
import { Config } from './interface/ICommon';
import { Index as L10n } from './l10n/Index';
import { store } from './store';
import { setConfig, setNow } from './store/mainSlice';

class App {
    constructor(_config: Config) {
        if (checkEnvPurpleZone()) {
            // 퍼플존 팝업의 pzsid, pzcid URL params를 sessionStorage에 설정
            const searchParams = getSearchParams(document.location.href);
            if (searchParams) {
                const purplezoneServerId = searchParams[PURPLEZONE_SERVER_ID_KEY];
                if (purplezoneServerId) {
                    sessionStorage.setItem(PURPLEZONE_SERVER_ID_KEY, purplezoneServerId);
                }

                const purplezoneCharacterId = searchParams[PURPLEZONE_CHARACTER_ID_KEY];
                if (purplezoneCharacterId) {
                    sessionStorage.setItem(PURPLEZONE_CHARACTER_ID_KEY, purplezoneCharacterId);
                }
            }
        }

        store.dispatch(setConfig(_config));
        store.dispatch(setNow('collection'));

        const container = document.querySelector('.collection-container')!;
        createRoot(container).render(
            <Provider store={store}>
                <L10n>
                    <Index />
                    <DetailIndex />
                </L10n>
            </Provider>
        );
    }
}
namespace('nc.info');
window.nc.info.collection = App;

/* 
* 검색
- /{appGroupCode}/v2.0/dict/search/collection
- https://sb-api-goats.plaync.com/search/docs/integrated.html#i-search-item_collection
* 컬렉션 아이템 아이디 검색
- /{appGroupCode}/v2.0/dict/search/collection?itemId=
- https://sb-api-goats.plaync.com/search/docs/integrated.html#i-search-item_collection_id
* 컬렉션 최저가 검색
- /{appGroupCode}/v2.0/dict/search/collection/{collectionId}/price
- https://sb-api-goats.plaync.com/search/docs/integrated.html#i-search-item_collection_price
* 등급 (카테고리)
- /{appGroupCode}/v2.0/game/collection/grade
- https://sb-api-goats.plaync.com/game/docs/integrated.html#integrated-collection-grade-list
* 옵션
- /{appGroupCode}/v2.0/game/collection/option
- https://sb-api-goats.plaync.com/game/docs/integrated.html#integrated-collection-option-list
*/
